(function () {
  'use strict';

  var STORAGE_KEY = 'ultd_size_profile';
  var SIZE_ORDER = ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XXG'];

  function toNumber(value) {
    if (value === '' || value === null || value === undefined) return null;
    var n = parseFloat(String(value).replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function loadProfile() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function saveProfile(profile) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
    } catch (e) {
      /* localStorage indisponível: apenas ignora */
    }
  }

  function scoreRow(row, m) {
    // Altura e peso são uma estimativa rápida (peso 1). Medidas diretas do
    // corpo (busto/tórax, cintura, quadril) são mais confiáveis quando o
    // cliente as informa, então contam mais no cálculo (peso 2).
    var fields = [
      ['altura', row.altura_min, row.altura_max, 1],
      ['peso', row.peso_min, row.peso_max, 1],
      ['busto_torax', row.busto_torax_min, row.busto_torax_max, 2],
      ['cintura', row.cintura_min, row.cintura_max, 2],
      ['quadril', row.quadril_min, row.quadril_max, 2]
    ];
    var totalWeighted = 0;
    var totalWeight = 0;

    fields.forEach(function (f) {
      var key = f[0];
      var min = f[1];
      var max = f[2];
      var weight = f[3];
      var val = m[key];
      if (val === null || val === undefined || min === null || max === null) return;
      totalWeight += weight;
      if (val >= min && val <= max) return;
      var dist = val < min ? (min - val) : (val - max);
      var width = Math.max(max - min, 1);
      totalWeighted += weight * (dist / width);
    });

    return totalWeight > 0 ? totalWeighted / totalWeight : Infinity;
  }

  function pickBestSize(rows, measurements) {
    var sorted = rows.slice().sort(function (a, b) {
      return SIZE_ORDER.indexOf(a.tamanho) - SIZE_ORDER.indexOf(b.tamanho);
    });

    var best = null;
    var bestScore = Infinity;

    sorted.forEach(function (row) {
      var s = scoreRow(row, measurements);
      if (s < bestScore) {
        bestScore = s;
        best = row;
      }
    });

    return { row: best, score: bestScore };
  }

  function selectVariantSize(root, size) {
    var container = root.closest('.product, .product__info-wrapper, body') || document;
    var variantSelects = container.querySelector('variant-selects') || document.querySelector('variant-selects');
    if (!variantSelects) return { ok: false, disabled: false };

    var input = null;
    try {
      input = variantSelects.querySelector('input[type="radio"][value="' + CSS.escape(size) + '"]');
    } catch (e) {
      var radios = variantSelects.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === size) {
          input = radios[i];
          break;
        }
      }
    }

    if (input) {
      var disabled = input.classList.contains('disabled');
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return { ok: true, disabled: disabled };
    }

    var select = variantSelects.querySelector('select');
    if (select) {
      var found = false;
      Array.prototype.forEach.call(select.options, function (opt) {
        if (opt.value === size) found = true;
      });
      if (found) {
        select.value = size;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return { ok: true, disabled: false };
      }
    }

    return { ok: false, disabled: false };
  }

  function initWidget(root) {
    var openBtn = root.querySelector('[data-size-advisor-open]');
    var modal = root.querySelector('[data-size-advisor-modal]');
    var closeEls = root.querySelectorAll('[data-size-advisor-close]');
    var form = root.querySelector('[data-size-advisor-form]');
    var resultBox = root.querySelector('[data-size-advisor-result]');
    var resultSize = root.querySelector('[data-size-advisor-result-size]');
    var resultNote = root.querySelector('[data-size-advisor-result-note]');
    var selectBtn = root.querySelector('[data-size-advisor-select]');
    var retryBtn = root.querySelector('[data-size-advisor-retry]');
    var rowsScript = root.querySelector('[data-size-advisor-rows]');
    var messageEl = root.querySelector('[data-size-advisor-message]');

    if (!openBtn || !modal || !form || !rowsScript) return;

    var rows = [];
    try {
      rows = JSON.parse(rowsScript.textContent);
    } catch (e) {
      rows = [];
    }
    if (!rows.length) return;

    var lastPicked = null;

    function clearMessage() {
      if (messageEl) {
        messageEl.textContent = '';
        messageEl.hidden = true;
      }
    }

    function openModal() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var profile = loadProfile();
      if (profile) {
        Object.keys(profile).forEach(function (key) {
          var input = form.querySelector('[name="' + key + '"]');
          if (input && profile[key] != null) input.value = profile[key];
        });
      }
      var firstInput = form.querySelector('input');
      if (firstInput) firstInput.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    openBtn.addEventListener('click', openModal);
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Validação: altura e peso são obrigatórios para o cálculo.
      var alturaVal = toNumber(form.altura.value);
      var pesoVal = toNumber(form.peso.value);
      if (alturaVal === null || alturaVal <= 0 || pesoVal === null || pesoVal <= 0) {
        if (messageEl) {
          messageEl.textContent = 'Informe altura e peso para calcular seu tamanho.';
          messageEl.hidden = false;
        }
        var firstEmpty = (alturaVal === null || alturaVal <= 0) ? form.altura : form.peso;
        if (firstEmpty && typeof firstEmpty.focus === 'function') firstEmpty.focus();
        return;
      }
      clearMessage();

      var cinturaInput = form.querySelector('[name="cintura"]');
      var bustoInput = form.querySelector('[name="busto_torax"]');
      var quadrilInput = form.querySelector('[name="quadril"]');

      var measurements = {
        altura: alturaVal,
        peso: pesoVal,
        cintura: cinturaInput ? toNumber(cinturaInput.value) : null,
        busto_torax: bustoInput ? toNumber(bustoInput.value) : null,
        quadril: quadrilInput ? toNumber(quadrilInput.value) : null
      };

      saveProfile(measurements);

      var result = pickBestSize(rows, measurements);
      if (!result.row) return;

      lastPicked = result.row.tamanho;

      resultSize.textContent = result.row.tamanho;
      resultNote.textContent = result.score === 0
        ? 'Suas medidas se encaixam perfeitamente nesse tamanho.'
        : 'Recomendação aproximada com base nas medidas informadas.';

      form.hidden = true;
      resultBox.hidden = false;
    });

    retryBtn.addEventListener('click', function () {
      clearMessage();
      resultBox.hidden = true;
      form.hidden = false;
    });

    selectBtn.addEventListener('click', function () {
      if (!lastPicked) return;
      var res = selectVariantSize(root, lastPicked);
      if (res.ok && res.disabled) {
        resultNote.textContent = 'Tamanho ' + lastPicked + ' selecionado, mas pode estar sem estoque nesta cor no momento.';
      }
      closeModal();
    });
  }

  function init() {
    var widgets = document.querySelectorAll('[data-size-advisor]');
    widgets.forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
